export var normalizeIssn = function (input) {
    var stripped = input.toUpperCase().replace(/[^0-9X]/g, "");
    if (!/^\d{7}[\dX]$/.test(stripped)) {
        return null;
    }
    var sum = 0;
    for (var i = 0; i < 7; i += 1) {
        sum += Number(stripped[i]) * (8 - i);
    }
    var remainder = sum % 11;
    var expected = remainder === 0 ? "0" : remainder === 1 ? "X" : String(11 - remainder);
    if (stripped[7] !== expected) {
        return null;
    }
    return "".concat(stripped.slice(0, 4), "-").concat(stripped.slice(4));
};
